



































































import BaseComponent from '@/components/base-component.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiDatePickerSingle from '@/components/UI/date-picker-single.vue';
import { parseStringToDate } from '@/helpers/dateUtils';
import * as moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiDatePickerRange,
    UiDatePickerSingle
  }
})
export default class ShippingQuoteRequestPatientDetailsModal extends BaseComponent {
  @Prop()
  public patient;

  @Prop()
  public dtoEdit;

  @Prop()
  public multi;

  @Prop()
  public closeEnabled;

  dialogFlag = true;
  dto: any = {};
  minDataPer = null;
  minDataDef = null;

  public form: any = {
    valid: false,
    rules: {
      tpMudancaEndereco: [(v) => v != null || 'Informe o tipo de mudança de endereço'],
      mudancaEndData: [(v) => this.validarData(v)],
      mudancaEndDatas: [(v) => this.validarPeriodo(v)]
    }
  };

  private headers: any = [
    { text: 'Endereço', value: 'endereco', sortable: false },
    { text: 'Tipo de bolsa', value: 'tipoBolsa', sortable: false, align: 'center' }
  ];

  validarData(v): boolean | string {
    if (v == null || v == '') {
      return 'Informe uma data válida';
    }

    if (!moment(v, 'DD/MM/YYYY').isValid()) {
      return 'Informe uma data válida';
    }

    if (moment(v, 'DD/MM/YYYY').isBefore(parseStringToDate(this.patient.diaMinAlterEndereco))) {
      return 'A data deve ser maior ou igual a ' + this.dateFormatHelper(this.patient.diaMinAlterEndereco, 'BR');
    }

    return true;
  }

  validarPeriodo(v): boolean | string {
    if (v == null || v == '') {
      return 'Informe o período';
    }
    let datas = v.split('-');
    if (datas.length < 2) {
      return 'Informe o período';
    }

    let val1 = this.validarData(datas[0].trim());
    if (val1 !== true) {
      return val1;
    }

    return this.validarData(datas[1].trim());
  }

  @Watch('dtoEdit', { immediate: true })
  onChangeDtoEdit() {
    this.dto = { ...this.dtoEdit };
    this.minDataPer = parseStringToDate(this.patient.diaMinAlterEndereco);
    this.minDataDef = parseStringToDate(this.patient.diaMinAlterEndereco);
  }

  salvar() {
    const form: any = this.$refs.form;
    form.validate();
    if (!this.form.valid) {
      return;
    }
    this.$emit('save', this.dto);
  }

  close() {
    this.$emit('close');
  }

  isAlterEnderTpBolsaDiferente() {
    return (
      (this.multi && this.patient.temEnderecoMulti == false) ||
      (this.multi === false && this.patient.temEnderecoMono === false)
    );
  }

  isPodeDesistir() {
    return this.isAlterEnderTpBolsaDiferente();
  }

  getNomeTipoBolsaExistente() {
    if (!this.isAlterEnderTpBolsaDiferente()) {
      return '';
    }
    if (this.multi) {
      return 'Comum/Mono';
    } else {
      return 'Multi';
    }
  }
}
